import { styled } from 'styled-components';

import { visuallyHidden } from '../../../../styles/common';
import ButtonAttachmentAction from '../ButtonAttachmentAction';

export const LabelWrapper = styled.div`
  align-items: stretch;
  display: flex;
  gap: var(--spacing-tiny);
  justify-content: space-between;
`;

export const ButtonPreview = styled.button`
  overflow: hidden;
  text-align: start;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const ButtonDownload = styled(ButtonAttachmentAction)`
  margin-right: var(--spacing-tiny);
`;

/**
 * Hidden link used in PreviewFragment
 */
export const HiddenLink = styled.a`
  ${visuallyHidden}
`;

export const Title = styled.p`
  overflow: hidden;
  text-align: start;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const Caption = styled.p`
  color: var(--color-text-caption);
  font-size: var(--font-sm);
  font-weight: var(--font-weight-text-caption);
`;
